import { render, staticRenderFns } from "./MatchDayBadge.vue?vue&type=template&id=b83b6ed6&scoped=true"
import script from "./MatchDayBadge.vue?vue&type=script&lang=js"
export * from "./MatchDayBadge.vue?vue&type=script&lang=js"
import style0 from "./MatchDayBadge.vue?vue&type=style&index=0&id=b83b6ed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83b6ed6",
  null
  
)

export default component.exports